import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=0f9149c9&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=0f9149c9&prod&lang=less&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&id=0f9149c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9149c9",
  null
  
)

export default component.exports